import { render, staticRenderFns } from "./workerMentor.vue?vue&type=template&id=4f1ec644&scoped=true"
import script from "./workerMentor.vue?vue&type=script&lang=js"
export * from "./workerMentor.vue?vue&type=script&lang=js"
import style0 from "./workerMentor.vue?vue&type=style&index=0&id=4f1ec644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ec644",
  null
  
)

export default component.exports